import Vue from 'vue'
import Router from 'vue-router'

// import Home from '@/components/Home'
import Map from '@/components/Map'
import More from '@/components/More'
import Review from '@/components/Review'
import Customer from '@/components/Customer'

Vue.use(Router)

export default new Router({
  // mode: 'history', // 히스토리 사용
  base: '/',
  linkActiveClass: 'active', // 사이드바 액티브 효과를 위한
  routes: [
    { path: '/', component: Map },
    // { path: '/home', component: Home },
    { path: '/map', component: Map },
    { path: '/modal', component: Map },
    { path: '/more', component: More },
    { path: '/review', component: Review },
    { path: '/customer', component: Customer },
    //
    { path: '/logout',
      beforeEnter (to, from, next) {
        // auth.logout()
        next('/')
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js